import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import map from 'lodash/map';
import Pill from '../../common/Pill';
import NavLink from './navLink';
import logoutImage from '../../../../images/logout.svg';
import NavigationButton from '../../main/timeTracker/containers/NavigationButtonContainer';

class Navigation extends Component {
  triggerResize = () => {
    window.dispatchEvent(new Event('resize'));
  };

  render() {
    const { navData, onItemClick } = this.props;
    const items = map(navData, ({ id, show, explainer = {}, label = {}, onClick, isActive, ...linkData }) => {
      if (!show) return false;
      const classnames = [];

      if (explainer.when) {
        classnames.push('is-highlight');
      }
      if (isActive) {
        classnames.push('is-active');
      }
      const className = classnames.join(' ');

      return (
        <li key={id} className="u-position-relative">
          <NavLink
            id={id}
            {...linkData}
            collapsed={this.context.collapsed}
            onClick={() => onItemClick(onClick)}
            className={className}
          />
          <div className="c-user-nav__pill" display-if={label.when && label.text}>
            <Pill className="u-block">{label.text}</Pill>
          </div>
          <explainer.component display-if={explainer.when && explainer.component} />
        </li>
      );
    });

    const logOutElement = this.context.collapsed ? null : <span className="c-user-nav__text">Log Out</span>;

    const logOutTitle = this.context.collapsed ? 'Log out' : null;

    return (
      <nav className="c-user-nav c-user-nav--appointments" onScroll={this.triggerResize} onWheel={this.triggerResize}>
        <ul className="list-bare c-user-nav--list">
          {this.props.children}

          {items}
          <li>
            <NavigationButton collapsed={this.context.collapsed} />
          </li>
          <li>
            <Link to="/sign-out" title={logOutTitle} className="c-user-nav__link">
              <img src={logoutImage} alt={logOutTitle} />
              {logOutElement}
            </Link>
          </li>
        </ul>
      </nav>
    );
  }
}

Navigation.propTypes = {
  navData: PropTypes.array.isRequired,
  children: PropTypes.node,
  onItemClick: PropTypes.func,
};

Navigation.defaultProps = {
  children: null,
  onItemClick: () => null,
};

Navigation.contextTypes = {
  collapsed: PropTypes.bool,
};

export default Navigation;
